import React from "react";

export default function EmptyEditor() {
  return (
    <>
      <div className="w-[62%] ">
        <div className="p-4 flex flex-col gap-2 border rounded h-[100%]">
          <p className="flex justify-center text-gray-600 font-medium">
            Please select or create a certificate to open editor.
          </p>
        </div>
      </div>
    </>
  );
}
